module.exports = __webpack_public_path__ + "img/vinacafe.cbc594ee.png";